




















import {Component,Vue} from "vue-property-decorator";

interface Item{
	title:string,
	isChecked:boolean
};

function memoryLoad<T>():T{
	return JSON.parse(localStorage.todo);
}

function memorySave<T>(memory:T):void{
	localStorage.todo=JSON.stringify(memory);
}

@Component
export default class Todo extends Vue{
	items:Item[]=[];
	newTitle=""

	mounted():void{
		try{
			this.items=memoryLoad();
		}
		catch{}
	}

	regist():void{
		memorySave(this.items);
	}

	addItem():void{
		this.items.push({title:this.newTitle,isChecked:false});
		this.newTitle="";
		this.regist();
	}

	delItem():void{
		this.items=this.items.filter(v=>!v.isChecked);
		this.regist();
	}
}
